var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSkipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/12px/Status/Skip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#4D94FF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,3 C8.41421356,3 8.75,3.33578644 8.75,3.75 L8.75,8.25 C8.75,8.66421356 8.41421356,9 8,9 C7.58578644,9 7.25,8.66421356 7.25,8.25 L7.25,6.467 L3.96451353,8.91699439 C3.93049372,8.95242612 3.88839326,8.97750693 3.84272348,8.9902906 L3.77210573,9 C3.62182588,9 3.5,8.873118 3.5,8.71660112 L3.5,8.71660112 L3.5,3.28339888 C3.5,3.20823682 3.5286682,3.13615321 3.57969792,3.08300561 C3.68596182,2.97233146 3.85824964,2.97233146 3.96451353,3.08300561 L3.96451353,3.08300561 L7.25,5.532 L7.25,3.75 C7.25,3.33578644 7.58578644,3 8,3 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSkipped);
export default __webpack_public_path__ + "static/media/status-skipped.c23c90f5389b72ecc9ac2813be498c5b.svg";
export { ForwardRef as ReactComponent };